import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { makeGetProductVariants, makeGetProductInfo } from '../../redux/product/selectors/ProductSelector';
import { ProductVariantButtons } from '../../components/product-detail/product-variant-buttons/ProductVariantButtons';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { getProductDetailUrl } from '../../util/ProductUtil';
const ProductVariantsContainer = () => {
    const { root } = useAemConfig();
    const productVariants = useSelector(makeGetProductVariants());
    const { productCode } = useSelector(makeGetProductInfo());
    const dispatch = useDispatch();
    const handleVariantClick = (variant) => () => {
        dispatch(analyticsActions.productVariantClick());
        window.location.href = getProductDetailUrl({ seoUrl: variant.productSeoUrl, colourId: variant.colorId }, root);
    };
    if ((productVariants === null || productVariants === void 0 ? void 0 : productVariants.length) === 0) {
        return null;
    }
    return (_jsx(ProductVariantButtons, { productVariants: productVariants, productCode: productCode, handleVariantClick: handleVariantClick }));
};
export default ProductVariantsContainer;
